import Modal from "aldoo-ra/Modal"

export default function PaymentError({ store }) {
  const {
    paymentInfo,
    paymentError,
    setPaymentError,
    showCheckout,
    getFragment,
  } = store

  const PaymentErrorFragment = getFragment("payment-error")

  const handleBackToPayment = () => {
    setPaymentError(null)
    showCheckout()
  }

  if (!paymentError || !paymentInfo) return null
  const modalConfig = store.config?.modals?.error || {}

  return (
    <Modal
      isOpen={!!paymentError}
      variant={modalConfig.variant || "aqua_medium"}
      className={modalConfig.className ?? "md:max-w-[550px]"}
      styleOverrides={modalConfig.styleOverrides}
      onClose={() => setPaymentError(null)}
    >
      <PaymentErrorFragment
        store={store}
        error={paymentError}
        handleBackToPayment={handleBackToPayment}
      />
    </Modal>
  )
}
